import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  Dimensions,
  Image,
  ScrollView,
} from "react-native";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import Tebleuserrank from "./tebleuserrank";
const { width, height } = Dimensions.get("window");
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";

export default function userrank({ navigation, route }) {
  const { id, title, distance } = route.params ?? {};
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState([]);
  const [lan, setlan] = useState("");

  const buildItems = (distances, language) =>
    Array.isArray(distances)
      ? distances.map((e) => ({
          ...e,
          label:
            (language == "en" ? "Distance " : "ระยะทาง ") +
            e.distance +
            (language == "en" ? " km (" : " กม. (") +
            e?.price +
            (language == "en" ? " baht)" : " บาท)"),
          value: e?.price,
        }))
      : [];

  const initialDistances = Array.isArray(distance?.distance)
    ? distance.distance
    : null;

  const [state, setState] = useState(initialDistances?.[0]?.price ?? null);
  const [Rank, setRank] = useState(null);
  const [EVENT, setEVENT] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [items, setItems] = useState(
    initialDistances ? buildItems(initialDistances, lan) : [],
  );

  async function getEventDetail() {
    if (!id || initialDistances) return;
    const response = await apiservice({
      path: "/event/getevent_select/" + id,
      method: "get",
      token: token?.accessToken,
    });
    if (response.status === 200) {
      const distances =
        response.data?.distances ?? response.data?.distance ?? [];
      setItems(buildItems(distances, lan));
      setState(distances?.[0]?.price ?? null);
    }
  }

  async function getevent(pageNum, append = false) {
    if (append) setLoadingMore(true);
    const response = await apiservice({
      path: "/event/getrankingByEvent_id/" + id + "?page=" + pageNum,
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      if (append) {
        setdata((prev) => [...prev, ...response.data.data]);
      } else {
        setdata(response.data.data);
      }
      if (response.data?.pagination) {
        setHasNext(response.data.pagination.hasNextPage ?? false);
      }
    }
    if (append) setLoadingMore(false);
  }

  function loadMore() {
    const nextPage = page + 1;
    setPage(nextPage);
    getevent(nextPage, true);
  }

  function handleScroll({ nativeEvent }) {
    const { layoutMeasurement, contentOffset, contentSize } = nativeEvent;
    const isCloseToBottom =
      layoutMeasurement.height + contentOffset.y >= contentSize.height - 20;
    if (isCloseToBottom && hasNext && !loadingMore) {
      loadMore();
    }
  }

  useEffect(() => {
    if (id && token?.accessToken) {
      getEventDetail();
    }
  }, [id, token]);

  useEffect(() => {
    setdata([]);
    setPage(1);
    setHasNext(false);
    getevent(1, false);
  }, [focus]);

  return (
    <View style={styles.container}>
      <ScrollView onScroll={handleScroll} scrollEventThrottle={400}>
        <View
          style={{
            width: width,
            height: width * 0.05,
            backgroundColor: "#fff",
          }}
        >
          <Image
            resizeMode="contain"
            style={{ width: width * 0.05, height: width * 0.05 }}
            source={require("../../image/lo_hor.png")}
          />
        </View>
        <View style={styles.back}>
          <View style={styles.viewfree}>
            <View style={{ flexDirection: "row" }}>
              <Text style={styles.textfree}>Rank</Text>
              <Text style={styles.textfree1}>
                {"       "}
                <Text style={styles.textfree}>{title}</Text>
              </Text>
            </View>
            <View style={{ marginTop: 10, marginRight: 30 }}>
              <RNPickerSelect
                value={state}
                textInputProps={{ style: { fontFamily: "Prompt-Regular" } }}
                onValueChange={(select) => {
                  setState(select);
                }}
                style={{
                  inputAndroid: {
                    width: width * 0.8,
                    height: 33,
                    borderBottomWidth: 1,
                    borderBottomColor: "#00000060",
                    color: "#000000",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                    paddingTop: 10,
                    zIndex: 999,
                    marginBottom: 10,
                  },
                }}
                items={items}
              />
            </View>
          </View>

          <Tebleuserrank
            navigation={navigation}
            data={data?.filter((e) => {
              return (
                state == e?.pay_status ||
                parseInt(state) + 35 == parseInt(e?.pay_status)
              );
            })}
          />

          {loadingMore && <Text style={styles.loadMoreText}>กำลังโหลด...</Text>}
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    alignItems: "center",
    alignSelf: "center",
  },
  viewfree: {
    width: width,
    flexDirection: "row",
    backgroundColor: "#393939",
    paddingVertical: 7,
    justifyContent: "space-between",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#fff",
    fontWeight: "bold",
    alignSelf: "center",
    marginLeft: 15,
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: width * 0.83,
    backgroundColor: "#fff",
    height: 100,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#fff",
    alignSelf: "center",
  },
  loadMoreText: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    alignSelf: "center",
    marginVertical: 16,
  },
});
